import classNames from 'classnames';
import { t } from 'ttag';
import { generatePath } from 'react-router-dom';

import { publicMemberProfile, checkoutBuyer } from '@urls';
import { useRegion } from '@hook/useRegion';
import { Title } from '@ui/Title';
import { Button } from '@ui/Button';
import { LocalizedLink } from '@ui/LocalizedLink';
import { MinOrderPriceSubscriptionBannerContainer } from '@containers/MinOrderPriceSubscriptionBanner';
import {
  BasketProduct,
  CartProduct,
} from '@components/CartProduct';

import s from './CartSellerProductsGroup.sss';

type Seller = {
  id: number
  username: string
  shopName?: string | null
};

type GroupInfo = {
  totalPrice: string
};

type CartSellerProductsGroupProps = {
  seller: Seller
  info: GroupInfo
  basketProducts: (BasketProduct & { id: number })[]
  onRequestRemoveProduct: (basketProductId: number) => void
  onUpdateBasketProductCount: (basketProductId: number, count: number) => void
  className?: string
};

export const CartSellerProductsGroup: React.FC<CartSellerProductsGroupProps> = ({
  seller,
  info,
  basketProducts,
  onRequestRemoveProduct,
  onUpdateBasketProductCount,
  className,
}) => {
  const { currencyName } = useRegion();

  const checkoutHref = generatePath(checkoutBuyer, { sellerId: seller.id });
  const sellerFeedPath = generatePath(publicMemberProfile, {
    username: seller.username,
  });
  const sellerTitle = seller.shopName || seller.username;

  return (
    (
      <div className={classNames(s.root, className)}>
        <Title type="h5">
          {t`Продавець: ${sellerTitle}`}
        </Title>
        <div className={s.products}>
          {basketProducts.map(
            (basketProduct) => (
              <CartProduct
                className={s.product}
                key={basketProduct.id}
                basketProduct={basketProduct}
                onRequestRemove={() => onRequestRemoveProduct(basketProduct.id)}
                onUpdateBasketProductCount={
                (count) => onUpdateBasketProductCount(
                  basketProduct.id,
                  count,
                )
              }
              />
            ),
          )}
        </div>
        <MinOrderPriceSubscriptionBannerContainer
          className={s.smartBanner}
          sellerId={seller.id}
        />
        <div className={s.buttons}>
          <LocalizedLink href={sellerFeedPath}>
            <Button
              theme="secondary"
              className={s.button}
            >
              {t`Додати інші товари продавця`}
            </Button>
          </LocalizedLink>

          <LocalizedLink href={checkoutHref}>
            <Button className={s.button}>
              {t`Оформити замовлення · ${info.totalPrice} ${currencyName}`}
            </Button>
          </LocalizedLink>
        </div>
      </div>
    )
  );
};
